module.exports = __webpack_public_path__ + "static/media/5.2.fee1afc5.jpg";